import styled from 'styled-components';
import IconButton from '../../atoms/IconButton_V2';
import ThemeV2 from '../../../componentsV2/theme';
import { StyledComponentProps } from './interface';

export const ModalBackground = styled.div<StyledComponentProps>`
  display: flex;
  flex-direction: row;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  background: ${ThemeV2.palette.gray1};
  border-radius: 2px;
  overflow: hidden;
  @media (max-width: 580px) {
    width: 100%;
    flex-wrap: wrap;
    overflow: auto;
  }
`;

export const ColumnLeft = styled.div`
  width: 375px;
  background: ${ThemeV2.palette.gray1};
  z-index: 1;
  border-right: ${`1px solid ${ThemeV2.palette.gray5}`};
  @media (max-width: 580px) {
    width: 100%;
  }
`;

export const ColumnRight = styled.div`
  width: 375px;
  padding: 16px 0px;
  background: ${ThemeV2.palette.gray3};
  @media (max-width: 580px) {
    width: 100%;
  }
`;

export const ColumnRightContent = styled.div`
  padding: 0px 24px;
  height: 500px;
  overflow-y: auto;
  @media (max-width: 580px) {
    height: auto;
  }
`;

export const ModalNavigation = styled.div`
  display: flex;
  width: 100%;
  padding: 0px 12px;
  box-sizing: border-box;
`;

export const ModalNavigationButton = styled(IconButton)`
  margin-right: 8px;
  &:disabled {
    & svg {
      opacity: 0.4;
    }
  }
`;

export const ModalCloseButton = styled(ModalNavigationButton)`
  margin-left: auto;
  margin-right: 0;
  padding: 0;
  width: 32px;
  height: 32px;

  &:hover {
    svg > rect {
      fill: ${ThemeV2.palette.geekBlue2};
    }
  }
`;
